import React from 'react';
import AnimatedSection from './AnimatedSection';
import './HeroSection.css';

const HeroSection = () => {
  const mainScreen = {
    id: 1,
    image: '/images/word-summer-main.jpg',
  };

  return (
    <AnimatedSection direction="fade" className="hero-section" id="hero">
      <div className="hero-layout">
        <div className="hero-media">
          <div className="screen-card">
            <div className="phone-frame">
              <div
                className="phone-screen"
                style={{
                  backgroundImage: `url(${mainScreen.image})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  backgroundColor: 'var(--phone-screen-bg)',
                }}
              />
            </div>
          </div>
        </div>

        <div className="hero-content">
          <h1 className="hero-title">
            <span className="title-accent">BG5 L.L.C-FZ</span>
          </h1>
          <p className="hero-description">
            BG5 L.L.C-FZ is a UAE-based mobile game publisher creating high-quality games and apps for iOS and Android.
          </p>
          <p className="hero-address">
            Meydan Grandstand, 6th floor, Meydan Road, Nad Al Sheba, Dubai, U.A.E.
          </p>
        </div>
      </div>
    </AnimatedSection>
  );
};

export default HeroSection;
